/**
 * Resolve a breadcrumb leaf label from a single slug-addressed row. Returns
 * `fallback` when there is no slug, the raw `slug` while the row is still
 * loading / the fetch errored / the slug is unknown, and the resolved label
 * once the row lands. Shared by PluginCrumb and TeamCrumb so the
 * loading/fallback semantics live in one place. (A failed fetch degrades to
 * the same fallback as "still loading" — callers that want to distinguish
 * the two check the query's `isError` themselves.)
 *
 * Deliberately takes ONE row, not a list. It used to take a list plus a
 * `matchesSlug` predicate, and both crumbs fed it a page of `useListXxx()` —
 * which resolved to the raw slug for every row past `pageSize`. The crumbs
 * now read the same slug-addressed query their page does, so there is no
 * list to scan and no signature inviting one. See ADR 0009.
 */
export function resolveCrumbLabel<T>(
  row: T | undefined,
  slug: string | undefined,
  toLabel: (row: T) => string,
  fallback: string,
): string {
  if (slug === undefined) return fallback;
  return row === undefined ? slug : toLabel(row);
}
